var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyInvestments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H10C10 13.6 9.6 14 9 14H7C6.4 14 6 13.6 6 13H0V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H12V1C12 0.4 11.6 0 11 0H5C4.4 0 4 0.4 4 1V4H1C0.4 4 0 4.4 0 5V11C0 11.6 0.4 12 1 12H6V11C6 10.4 6.4 10 7 10H9C9.6 10 10 10.4 10 11V12H15C15.6 12 16 11.6 16 11V5C16 4.4 15.6 4 15 4ZM10 4H6V2H10V4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyInvestments);
export default __webpack_public_path__ + "static/media/my-investments.0bd59d511ddfa702e798a3c90e79e54c.svg";
export { ForwardRef as ReactComponent };